import {createSlice} from "@reduxjs/toolkit";

const initialCampaignsState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  campaignForEdit: undefined,
  lastError: null
};
export const callTypes = {
  list: "list",
  action: "action"
};

export const campaignsSlice = createSlice({
  name: "campaign",
  initialState: initialCampaignsState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    campaignFetched: (state, action) => {
      state.actionsLoading = false;
      state.campaignForEdit = action.payload.campaignForEdit;
      state.error = null;
    },
    campaignsFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
    },
    campaignCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.entities.push(action.payload.campaign);
    },
    campaignUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.map(entity => {
        if (entity._id === action.payload.campaign._id) {
          return action.payload.campaign;
        }
        return entity;
      });
    },
    campaignDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(el => el._id !== action.payload.id);
    },
    // 
    campaignsDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(
        el => !action.payload.ids.includes(el._id)
      );
    },
   
  }
});
